import {
  newsDataSelector,
  newsLoadingSelector,
} from '../../../redux/dashboard/selectors';

export default (state) => ({
  news: newsDataSelector(state),
  isLoading: newsLoadingSelector(state),
});
